export enum CurrencySymbol {
  USD = "usd",
  AUD = "aud",
  ETH = "eth",
  BTC = "btc",
}
